export const REQUEST_HH_API_URL = {
  getRegions: () => "/v1/meta/regions",
  getFilters: () => "/v1/meta/filters",
  createRequestHH: () => "/v1/matching/cold_matching",
  getStructureVacancy: () => "/v1/matching/cold_matching/structure-vacancy",
  cancelStructuredVacancy: () => `/v1/users/attempts/consume`
};
